import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';

// Import components
import Menu from './components/Menu.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import CookieConsent from './components/CookieConsent.jsx';

// Import utilities
import { initializeMatomoIfConsented } from './utils/matomo';

// Import pages
import HomePage from './pages/HomePage.jsx';
import ServiceDepartment from './pages/ServiceDepartment.jsx';
import Preconstruction from './pages/Preconstruction.jsx';
import BimVdc from './pages/BimVdc.jsx';
import ConstructionCommissioning from './pages/ConstructionCommissioning.jsx';
import Manufacturing from './pages/Manufacturing.jsx';
import Pipe from './pages/Pipe.jsx';
import SheetMetal from './pages/SheetMetal.jsx';
import Technology from './pages/Technology.jsx';
import AboutUs from './pages/AboutUs.jsx';
import Management from './pages/Management.jsx';
import ManagerProfile from './pages/ManagerProfile.jsx';
import Safety from './pages/Safety.jsx';
import Careers from './pages/Careers.jsx';
import Legence from './pages/Legence.jsx';
import { Projects, ProjectDetail } from './pages/projects';
import { News, NewsArticle } from './pages/news';
import ContactUs from './pages/ContactUs.jsx';
import ColorSwatches from './pages/ColorSwatches.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Initialize Matomo only if user has previously consented to analytics
  useEffect(() => {
    initializeMatomoIfConsented();
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo">
              <img src="/images/Bel-Aire_Legence_Logo.png" alt="Bel-Aire Mechanical" className="logo-img" />
            </Link>
            <button 
              className="hamburger-menu"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          </div>
        </div>
        
        {/* Dropdown Menu */}
        <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
      </header>

      {/* Main Content */}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/service-department" element={<ServiceDepartment />} />
          <Route path="/preconstruction" element={<Preconstruction />} />
          <Route path="/bim-vdc" element={<BimVdc />} />
          <Route path="/construction-commissioning" element={<ConstructionCommissioning />} />
          <Route path="/manufacturing" element={<Manufacturing />} />
          <Route path="/pipe" element={<Pipe />} />
          <Route path="/sheet-metal" element={<SheetMetal />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/management" element={<Management />} />
          <Route path="/management/:managerId" element={<ManagerProfile />} />
          <Route path="/safety" element={<Safety />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/legence" element={<Legence />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:projectId" element={<ProjectDetail />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:newsId" element={<NewsArticle />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/colors" element={<ColorSwatches />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-main">
          <div className="container">
            <div className="footer-content">
              <div className="footer-section footer-contact">
                <h4>Contact Us</h4>
                <div className="footer-info-group">
                  <p className="footer-address">4201 N 47th Avenue<br />Phoenix, AZ 85031</p>
                  <p className="footer-phone">
                    <a href="tel:623-846-8600">Office: (623) 846-8600</a>
                  </p>
                </div>
              </div>
              
              <div className="footer-section footer-licenses">
                <h4>Arizona Contractor Licenses</h4>
                <div className="license-list">
                  <div className="license-item">
                    <span className="license-number">ROC070688 C-39</span>
                    <span className="license-type">Air Conditioning & Refrigeration</span>
                  </div>
                  <div className="license-item">
                    <span className="license-number">ROC070689 CR-45</span>
                    <span className="license-type">Sheet Metal</span>
                  </div>
                  <div className="license-item">
                    <span className="license-number">ROC186439 C-37</span>
                    <span className="license-type">Plumbing</span>
                  </div>
                  <div className="license-item">
                    <span className="license-number">ROC193793 C-4</span>
                    <span className="license-type">Boilers, Steam Fitting, Process Pipe</span>
                  </div>
                </div>
              </div>
              
              <div className="footer-section footer-hours">
                <h4>Service Department</h4>
                <p className="footer-highlight">24/7 Emergency Service Available</p>
                <div className="hours-list">
                  <div className="hours-item">
                    <span className="hours-day">Monday - Friday</span>
                    <span className="hours-time">7:00 AM - 4:00 PM</span>
                  </div>
                  <div className="hours-item">
                    <span className="hours-day">Saturday - Sunday</span>
                    <span className="hours-time">Closed</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="container">
            <p>&copy; 2024 Bel-Aire Mechanical. All rights reserved. | <Link to="/privacy-policy" style={{ color: 'var(--gray-300)', textDecoration: 'none' }}>Privacy Policy</Link> | Designed by Voicelessmail LLC.</p>
          </div>
        </div>
        </footer>

        {/* Cookie Consent Banner */}
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
